import React, { useEffect, useRef } from 'react'
import styled from 'styled-components'

type Props = {
  url: string
}

let script = null
let isLoad = false

const Container = styled.div`
  /**
   * Max:
   *   position: relative 一定要有
   *   iframe 進入 loading 時會是 position: absolute
   *   若無 position: absolute 會造成 iframe width 錯誤
   */
  position: relative;
  cursor: pointer;
  margin-bottom: 10px;

  & > * {
    width: 100%;
    display: block;
  }

  // 蓋過預設 blockquote 的權重
  blockquote.instagram-media,
  blockquote.instagram-media-registered {
    border: none;
    padding: 0;
  }
`

const Placeholder = styled.div`
  padding-top: 54px;
  padding-bottom: 152px;

  &::before {
    content: '';
    display: block;
    padding-top: 100%;
  }
`

function InstagramEmbed(props: Props) {
  const { url } = props
  const ref = useRef(null)

  useEffect(() => {
    const adjustHeight = (e) => {
      const iframe = ref.current.querySelector('iframe')

      if (e.source !== iframe?.contentWindow) return

      const data = JSON.parse(e.data)

      if (!data?.details?.height) return

      iframe.style.height = data?.details?.height + 'px'
    }

    window.addEventListener('message', adjustHeight)

    return () => window.removeEventListener('message', adjustHeight)
  }, [])

  useEffect(() => {
    if (isLoad) return window.instgrm.Embeds.process()
    if (script) return

    script = document.createElement('script')
    script.async = 'async'
    script.src = '//www.instagram.com/embed.js'
    script.onload = () => (isLoad = true)
    document.body.append(script)
  }, [])

  return (
    <Container ref={ref}>
      <blockquote
        className="instagram-media"
        data-instgrm-permalink={url}
        data-instgrm-version="12"
      >
        <Placeholder />
      </blockquote>
    </Container>
  )
}

export default InstagramEmbed
